module.exports = __webpack_public_path__ + "img/d011_1.bab0cd26.jpeg";